import { Text } from '../Text';
import { Tooltip, TooltipFocusableTrigger } from '../Tooltip';
import { Icon } from '@zapier/zinnia-icons';
import clsx from 'clsx';
import {
  Column as AriaColumn,
  ColumnResizer,
  type ColumnProps as AriaColumnProps,
} from 'react-aria-components';
import styles from './DataTable.module.scss';

type DataTableColumnProps = AriaColumnProps & {
  /** Column header content */
  children: React.ReactNode;
  /** Additional inline styles */
  style?: React.CSSProperties;
  /** Whether the column allows resizing */
  allowsResizing?: boolean;
  /** Tooltip to show when sorting is disabled */
  sortDisabledTooltip?: string;
};

export const DataTableColumn = ({
  children,
  id,
  allowsSorting,
  isRowHeader,
  className,
  style,
  defaultWidth,
  minWidth,
  maxWidth,
  allowsResizing,
  sortDisabledTooltip,
  ...rest
}: DataTableColumnProps) => {
  return (
    <AriaColumn
      id={id}
      allowsSorting={allowsSorting}
      isRowHeader={isRowHeader}
      className={clsx(styles.th, className)}
      style={style}
      defaultWidth={defaultWidth}
      minWidth={minWidth}
      maxWidth={maxWidth}
      {...rest}
    >
      <span className={styles.thSortable}>
        {sortDisabledTooltip ? (
          <Tooltip allowMultiline content={sortDisabledTooltip} placement="top">
            <TooltipFocusableTrigger>
              <Text type="SmallPrint2">{children}</Text>
            </TooltipFocusableTrigger>
          </Tooltip>
        ) : (
          <Text type="SmallPrint2">{children}</Text>
        )}
        {allowsSorting && (
          <>
            <span className={styles.sortableIcon}>
              <Icon name="arrowDropdown" size={16} color="TextDefault" />
            </span>
            <span className={styles.sortedIcon}>
              <Icon name="arrowBigUp" size={16} color="TextDefault" />
            </span>
          </>
        )}
      </span>
      {allowsResizing && (
        <ColumnResizer className={styles.columnResizer}>
          <div className={styles.columnResizerHandle} />
        </ColumnResizer>
      )}
    </AriaColumn>
  );
};
